module.exports = __webpack_public_path__ + "img/rz_04.97c2d8e1.png";